<div class="circle" [attr.data-letters]="dataLetters"> </div>
